import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import {
  BackendConsumosPorCaso,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_ConsumoPorCaso from "../../../dataJson/consumoPorCaso.json";
import { formatearMensajeBackend } from "../../../apis/helper/helperApi";
import { TypeStatus } from "../../helpers/constantes";

interface State {
  itemConsumoPorCaso: any[];
  itemConsumoTarea: any[];
  consumoPorCaso: string;
  status: TypeStatus;
  isLoading: boolean;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
}

const initialState: State = {
  itemConsumoPorCaso: [],
  itemConsumoTarea: [],
  consumoPorCaso: "",
  status: "idle",
  isLoading: false,

  error: null,
  Success: false,
  Mensaje: null,
};

interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};
const itemConsumoPorCasoSlice = createSlice({
  name: "itemConsumoPorCaso",
  initialState,
  reducers: {
    setItemConsumoPorCaso: (state, action: PayloadAction<any[]>) => {
      state.itemConsumoPorCaso = action.payload;
    },
    getItemConsumoPorCaso: (state, action: PayloadAction<any[]>) => {
      state.itemConsumoPorCaso = action.payload;
    },
    setConsumoPorCaso: (state, action: PayloadAction<string>) => {
      state.consumoPorCaso = action.payload;
    },
    setConsumoTarea: (state, action: PayloadAction<any[]>) => {
      state.itemConsumoTarea = action.payload;
    },
    setClearItemConsumoPorCaso: (state, action: PayloadAction<any[]>) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
  },
});

export const setBackendItemConsumoPorCaso =
  (IdCaso: number): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));

    try {
      const response: AxiosResponse = await BackendConsumosPorCaso(IdCaso);

      const isError =
        response.data?.Success === false ||
        (response.data?.ResultadoSolicitud !== undefined &&
          response.data?.ResultadoSolicitud !== 200);

      if (isError) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        dispatch(setSuccess(false));
      } else {
        dispatch(setItemConsumoPorCaso(response.data.Data));
        if (response.data.Data && response.data.Data.length > 0) {
          dispatch(
            setConsumoPorCaso(
              String(response.data.Data[0].HorasConsPond),
            ),
          );
        }
        if (
          mock_ConsumoPorCaso.Data &&
          mock_ConsumoPorCaso.Data.length > 0
        ) {
          dispatch(setConsumoTarea(mock_ConsumoPorCaso.Data[0].Tareas));
        }
        dispatch(setIsLoading(false));
        dispatch(setStatus("succeeded"));
        dispatch(setSuccess(true));
      }
      dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));

      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setSuccess(false));
      dispatch(setStatus("failed"));

      if (error.response?.status === 401) {
        dispatch(setStatus("noAutorice"));
        dispatch(
          setMensaje(
            formatearMensajeBackend(
              "Tu sesión ha expirado. Vuelve a iniciar sesión",
            ),
          ),
        );
      } else if (error.response) {
        // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
        console.error(
          "Error de servidor:",
          error.response.status,
          error.response.data,
        );

        const errorData = error.response.data;
        const mensajeBackend = errorData?.Mensaje;
        const resultadoSolicitud = errorData?.ResultadoSolicitud;

        if (
          mensajeBackend &&
          (resultadoSolicitud !== 200 || errorData?.Success === false)
        ) {
          dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
        } else {
          dispatch(
            setMensaje(
              `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
            ),
          );
        }
      } else if (error.request) {
        console.error("Error de conexión:", error.message);
        dispatch(
          setMensaje(
            "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
          ),
        );
      } else {
        console.error("Error de red o solicitud:", error.message);
        dispatch(
          setMensaje(
            "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
          ),
        );
      }
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
      if (getCurrentDomain() === "localhost") {
        dispatch(setIsLoading(true));

        const mockData: any = mock_ConsumoPorCaso;
        const isErrorMock =
          mockData?.Success === false ||
          (mockData?.ResultadoSolicitud !== undefined &&
            mockData?.ResultadoSolicitud !== 200);

        if (isErrorMock) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          dispatch(setItemConsumoPorCaso(mock_ConsumoPorCaso.Data));
          if (
            mock_ConsumoPorCaso.Data &&
            mock_ConsumoPorCaso.Data.length > 0
          ) {
            dispatch(
              setConsumoPorCaso(
                String(mock_ConsumoPorCaso.Data[0].HorasConsPond),
              ),
            );
          }
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
        }
        dispatch(
          setMensaje(formatearMensajeBackend(mock_ConsumoPorCaso.Mensaje)),
        );
        const mock401 = await import("../../../dataJson/401.json");
        if (mock401.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        }
      }
    }
  };

export const setBackendClearItemConsumoPorCaso =
  (): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    try {
      let response: AxiosResponse = defaultResp;
      dispatch(setItemConsumoPorCaso([]));
      dispatch(setIsLoading(false));
      dispatch(setStatus("idle"));
      dispatch(setSuccess(false));
      dispatch(setMensaje(""));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const {
  setItemConsumoPorCaso,
  getItemConsumoPorCaso,
  setConsumoPorCaso,
  setConsumoTarea,
  setClearItemConsumoPorCaso,
  setIsLoading,
  setStatus,
  setResult,
  setMensaje,
  setSuccess,
} = itemConsumoPorCasoSlice.actions;

export default itemConsumoPorCasoSlice.reducer;
